/* Merken-Knopf am Fuss der Kaufbox (Entwurf).

   Teilt Speicher und Meldung mit product-actions.js: dieselbe Liste
   'rc-merkliste', dasselbe Ereignis 'rc:save-change'. Sonst haetten Herz
   und Knopf auf derselben Seite getrennte Zustaende — ein Klick auf das
   eine liesse das andere falsch stehen.

   Vanilla, kein Framework, `defer` geladen. */
(() => {
  const SCHLUESSEL = 'rc-merkliste';

  const lesen = () => {
    try { return JSON.parse(localStorage.getItem(SCHLUESSEL)) || []; }
    catch (e) { return []; }
  };

  const knoepfe = Array.from(document.querySelectorAll('[data-rc-wishlist]'));
  if (!knoepfe.length) return;

  const angleichen = () => {
    const liste = lesen();
    knoepfe.forEach((k) => {
      const drin = liste.includes(k.dataset.productHandle);
      k.classList.toggle('is-active', drin);
      k.setAttribute('aria-pressed', String(drin));
      if (k.dataset.labelSaved && k.dataset.labelDefault) {
        k.textContent = drin ? k.dataset.labelSaved : k.dataset.labelDefault;
      }
    });
  };

  knoepfe.forEach((k) => {
    k.addEventListener('click', () => {
      const handle = k.dataset.productHandle;
      if (!handle) return;
      let liste = lesen();
      liste = liste.includes(handle) ? liste.filter((h) => h !== handle) : liste.concat(handle);
      try { localStorage.setItem(SCHLUESSEL, JSON.stringify(liste)); }
      catch (e) { /* Privater Modus: der Zustand bleibt dann nur in dieser Ansicht. */ }
      document.dispatchEvent(new CustomEvent('rc:save-change'));
      angleichen();
    });
  });

  document.addEventListener('rc:save-change', angleichen);
  window.addEventListener('storage', angleichen);
  angleichen();
})();
